module.exports = __webpack_public_path__ + "static/media/Graphik-Semibold.e0c82249.woff2";